import { render, staticRenderFns } from "./UserContentType.vue?vue&type=template&id=1fe801fc&"
import script from "./UserContentType.vue?vue&type=script&lang=ts&"
export * from "./UserContentType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports